var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"chevron",class:{ 'right': _vm.right,'up': _vm.up,'down': _vm.down },attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M11.561 11.625l3.5 4.375-1.561 1.25L9 11.624 13.5 6l1.562 1.25-3.5 4.375z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }